import { createSlice } from "@reduxjs/toolkit";

const usageSlice = createSlice({
  name: "usage",
  initialState: {
    usage: [""], // Renamed for clarity
  },
  reducers: {
    setUsage: (state, action) => {
      state.usage = action.payload; // Updated key to match initialState
    },
  },
});

export const { setUsage } = usageSlice.actions;
export default usageSlice.reducer;
